/**
 * A2P bypass list — SINGLE SOURCE OF TRUTH.
 *
 * A designated tester account (a friend with no real business, signed up so we
 * can walk a fresh tenant through the real onboarding UX) skips carrier
 * registration entirely. On a match, onboarding treats the A2P requirement as
 * satisfied: the talk-track approval jumps straight to activation, and
 * /v2/finalize provisions the number on the SHARED trial subaccount (the
 * pre-approved campaign) instead of a dedicated one the tenant never created.
 * Once finalize succeeds they are fully live — nothing downstream gates on A2P.
 *
 * Matched on the SUPABASE AUTH EMAIL only, never tenants.notification_email.
 * Auth email is immutable from the tenant's side; notification_email is a
 * user-editable settings field, so keying on it would let any tenant grant
 * themselves the bypass by typing a tester's address into their settings.
 *
 * CommonJS on purpose: required by Express (src/api_routes) AND imported by the
 * React bundle. Same arrangement as planPricing.js.
 *
 * To add a tester: add the lowercase address here. Nowhere else.
 */
const A2P_BYPASS_EMAILS = [
  'claude.o86@gmail.com',
  'leon@getsurfox.com',
  'kara.johnson@baramundi.com',
];

/** Exact, case-insensitive match. Empty/null is always false. */
function isA2PBypassEmail(email) {
  if (!email || typeof email !== 'string') return false;
  return A2P_BYPASS_EMAILS.includes(email.trim().toLowerCase());
}

module.exports = { A2P_BYPASS_EMAILS, isA2PBypassEmail };
